import cntl from "cntl";
import PropTypes from "prop-types";
import { cloneElement, Children, Fragment } from "react";

const propTypes = {
  isLeading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  childGap: PropTypes.string,
  textAlign: PropTypes.string,
  className: PropTypes.string,
  supportingText: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
};

function CellBodyDatagrid({
  text,
  children,
  childGap,
  className,
  supportingText,
  isLeading = false,
  textAlign = "left",
  isDisabled = false,
}) {
  const wrapperCell = () => cntl`
    flex
    text-sm
    items-center
    ${childGap ? childGap : cntl`gap-x-3`}
    ${isDisabled && cntl`bg-gray-light-2 dark:bg-gray-dark-2`}
    ${textAlign === "left" ? cntl`justify-start` : cntl`justify-end`}
    ${className ? className : undefined}
  `;

  const wrapperText = () => cntl`
    flex
    flex-col
  `;

  const textCn = () => cntl`
  truncate-line-1
    ${
      isLeading
        ? cntl`font-medium text-gray-light-12 dark:text-gray-dark-11`
        : supportingText?.length
        ? cntl`font-regular text-gray-light-11 dark:text-gray-dark-11`
        : cntl`font-medium text-gray-light-11 dark:text-gray-dark-11`
    }
  `;

  const supportingTextCn = () => cntl`
    truncate-line-1
    text-gray-light-11 dark:text-gray-dark-11
  `;

  return (
    <div className={wrapperCell()}>
      {children &&
        Children.map(children, (child, index) => {
          if (child) {
            return (
              <Fragment key={index}>
                {cloneElement(child)}
              </Fragment>
            );
          }
        })}
      {(!!text || !!supportingText?.length) && (
        <div className={wrapperText()}>
          {!!text && <span className={textCn()}>{text}</span>}
          {!!supportingText?.length && <span className={supportingTextCn()}>{supportingText}</span>}
        </div>
      )}
    </div>
  );
}

CellBodyDatagrid.propTypes = propTypes;
export default CellBodyDatagrid;
